module.exports = __webpack_public_path__ + "img/ic-statistics.91e37d1f.svg";